// @flow

const splitLetters = (name: string): string => (
  name.split(' ').reduce(
    (list, [firstLetter]) => (list + firstLetter),
    '',
  ).replace(/[^a-zA-Z]/gi, '')
);

export default splitLetters;
